import { ListItem, ListItemIcon, ListItemIconProps, ListItemText, Stack, styled } from "@mui/material";
import React from "react";
import { IControl, IMutator, Nullable } from "sonobello.utilities.react";
import { LeafLogoSvg, SBPalette } from "sonobello.utilities.react.mui";

import theme from "../../../../assets/Theme";
import IMedicalFormElementProps from "../Types/IMedicalFormElement";

export interface IMedicalQuestionConfig {
  text: string;
  questionId: string;
  FormElement: Nullable<React.FC<IControl<Nullable<boolean>> & IMutator<boolean>>>;
  ChildFormItem: Nullable<React.FC<IMedicalFormElementProps>>;
}

interface FormQuestionIconProps extends ListItemIconProps {
  isMobile: boolean;
}

const FormQuestionIcon = styled(ListItemIcon, {
  shouldForwardProp: propName => propName !== "isMobile"
})<FormQuestionIconProps>(({ isMobile, theme }) => ({
  minWidth: isMobile ? theme.spacing(4) : undefined
}));

const BaseMedicalQuestion: React.FC<IMedicalFormElementProps & IMedicalQuestionConfig> = ({
  isMobile,
  questionId,
  text,
  value,
  onChange,
  FormElement,
  ChildFormItem,
  ...rest
}) => {
  return (
    <>
      <ListItem sx={{ px: isMobile ? 0 : undefined, display: "flex", justifyContent: "space-between" }}>
        <Stack direction="row" spacing={isMobile ? 4 : 0} alignItems="center">
          <FormQuestionIcon isMobile={isMobile}>
            <LeafLogoSvg
              fill={SBPalette.dark.watermarkGray.main}
              style={{ height: theme.spacing(3), width: theme.spacing(3) }}
            />
          </FormQuestionIcon>
          <ListItemText primary={text} sx={{ pr: 2 }} />
        </Stack>
        {FormElement && (
          <ListItemIcon>
            <FormElement
              value={value[questionId] ?? null}
              onChange={answer => onChange({ ...value, [questionId]: answer })}
            />
          </ListItemIcon>
        )}
      </ListItem>
      {ChildFormItem && <ChildFormItem {...rest} isMobile={isMobile} value={value} onChange={onChange} />}
    </>
  );
};

export default BaseMedicalQuestion;
